import React, { FC } from 'react';

import NewsItem from '../NewsItem';
import Pagination from '../../Pagination';

import { INewsContent } from './interfaces';

import './styles.scss';

// news content
const NewsContent: FC<INewsContent> = ({
  data,
  lang,
  page,
  onNextPrev,
  perPage,
  prefix
}) => {
  // render
  return (
    <div
      className="news-content">
      <div
        className="news-content--container">
        {data?.items && data?.items.map((item: any, index: number) =>
          <NewsItem
            {...item}
            lang={lang}
            prefix={prefix}
            key={index} />)}
      </div>
      
      {data?.meta &&
        <Pagination
          current={page}
          total={Math.ceil(data?.meta.total_count / perPage)}
          setCurrent={onNextPrev} />}
    </div>
  );
};

export default NewsContent;